/**
 * Tracking Data
 *
 * Hardcoded tracking payloads per template.
 * TODO: Replace with backend-driven trackingInfo from CBackend responses.
 */
import type { TrackingInfo } from '@contracts';
import { TEMPLATE_TYPES } from '@/features/chat/constants/templateTypes';
import { TRACKING_IDS } from './trackingIds';

export const TRACKING_DATA: Record<string, TrackingInfo> = {
  [TEMPLATE_TYPES.FLIGHTS_LISTING_SPLIT]: {
    common: {
      omniture: {
        pageName: 'myra:ai:flights:listing',
        eVar15: 'myra:ai:flights:listing',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.FLIGHTS_LISTING_LOADED }],
    },
  },
  [TEMPLATE_TYPES.FLIGHTS_REVIEW_INTERSTITIAL]: {
    common: {
      omniture: {
        pageName: 'myra:ai:flights:details',
        eVar15: 'myra:ai:flights:details',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.FLIGHTS_DETAILS_LOADED }],
    },
  },
  [TEMPLATE_TYPES.FLIGHTS_REVIEW_TRAVELLERS]: {
    common: {
      omniture: {
        pageName: 'myra:ai:flights:review',
        eVar15: 'myra:ai:flights:review',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.FLIGHTS_REVIEW_LOADED }],
    },
  },
  [TEMPLATE_TYPES.FLIGHTS_THANKYOU]: {
    common: {
      omniture: {
        pageName: 'myra:ai:flights:thankyou',
        eVar15: 'myra:ai:flights:thankyou',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.FLIGHTS_BOOKED }],
    },
  },
  [TEMPLATE_TYPES.HOTELS_LISTING]: {
    common: {
      omniture: {
        pageName: 'myra:ai:hotels:listing',
        eVar15: 'myra:ai:hotels:listing',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.STAY_LISTING_LOADED }],
    },
  },
  [TEMPLATE_TYPES.HOTEL_DETAILS]: {
    common: {
      omniture: {
        pageName: 'myra:ai:hotels:details',
        eVar15: 'myra:ai:hotels:details',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.STAY_DETAILS_LOADED }],
    },
  },
  [TEMPLATE_TYPES.HOTEL_REVIEW]: {
    common: {
      omniture: {
        pageName: 'myra:ai:hotels:review',
        eVar15: 'myra:ai:hotels:review',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.STAY_REVIEW_LOADED }],
    },
  },
  [TEMPLATE_TYPES.HOTELS_THANKYOU]: {
    common: {
      omniture: {
        pageName: 'myra:ai:hotels:thankyou',
        eVar15: 'myra:ai:hotels:thankyou',
      },
    },
    pageLoad: {
      omniture: [{ prop54: TRACKING_IDS.STAY_BOOKED }],
    },
  },
};
